import { RequestParams } from 'utils/mapParams';
import httpService, { HttpService } from './httpService';
import { CommonRequestParams } from '../models/dto/params.dto';
import { createContract, UpdateContract } from 'models/interfaces/createContract.interface';

export class ContractsService {
  constructor(private _httpService: HttpService) {}

  async getContracts(params: Partial<RequestParams>) {
    const res = this._httpService.get('/business/contracts', { queryStringParameters: params });
    return res;
  }

  async getContractById(data: { id: number; params?: CommonRequestParams }) {
    const res = await this._httpService.get(`/business/contracts/${data.id}`, {
      queryStringParameters: data.params,
    });

    return res;
  }

  async createContract(params: createContract) {
    const res = this._httpService.post('/business/contracts', { body: params });
    return res;
  }

  async updateContract(params: { id: number; values: UpdateContract }) {
    const res = await this._httpService.put(`/business/contracts/${params.id}`, {
      body: params.values,
    });
    return res;
  }
}

const contractsService = new ContractsService(httpService);

export default contractsService;
